/* eslint-disable no-constant-condition */
import { useEffect } from 'react'
import { getAuthToken, setAuthToken } from 'library/FetchHelper'
import { useDispatch } from 'react-redux'
import { CACHE_TOKEN } from 'config/constants'
import { useWeb3React } from '@web3-react/core'
import { setIslogin } from 'state/auth/actions'

const useCheckAuthorization = () => {
  const dispatch = useDispatch()
  const { account } = useWeb3React()
  const token = getAuthToken().get(CACHE_TOKEN)

  useEffect(() => {
    if (token && account) {
      setAuthToken(token)
      dispatch(setIslogin(true))
    } else {
      dispatch(setIslogin(false))
    }
  }, [account, dispatch, token])
}

export default useCheckAuthorization
